import React, { useEffect, useState } from 'react'
import { NavigationContainer } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import { useSelector } from 'react-redux'
import { LinkingConfiguration } from '../config/navigation'

import SignedInNavigator from './SignedInNavigator'
import SignedOutNavigator from './SignedOutNavigator'
import {
  NotFoundScreen,
  ResetPasswordScreen,
  VerifyEmailAddressScreen,
} from '../screens/general'
import ModalPatientGroup from '../components/HGModal/ModalPatientGroup'
import { LocationChoiceType } from '../config/types'
import ModalPrivacy from '../components/HGModal/ModalPrivacy'

export type RootStackParamList = {
  SignedIn: unknown
  SignedOut: unknown
  StartOverviewChildren: unknown
  Documentation: unknown
  Onboarding: unknown
  SignUp: unknown
  SignUpSecond: { registrationCode: string }
  News: unknown
  NewsDetail: { newsId: string; title?: string }
  GenericResource: {
    resourceId: string
    slug?: string
    name?: string
  }
  GenericLocations: {
    districtId: string
    locationTypes: LocationChoiceType
    name?: string
  }
  // General
  ResetPassword: {
    token: string
  }
  VerifyEmailAddress: {
    token: string
    email?: string
  }
  NotFound: unknown
}

const Stack = createStackNavigator<RootStackParamList>()

const AppNavigator = () => {
  const { loggedIn, patientGroupModalVisible, privacyAccepted } = useSelector(
    (state) => state.user
  )
  const globals = useSelector((state) => state.globals)
  const [modalPrivacyVisible, setModalPrivacyVisible] = useState<boolean>(false)

  useEffect(() => {
    if (!!globals && loggedIn && privacyAccepted === false) {
      setModalPrivacyVisible(true)
    }
  }, [loggedIn, privacyAccepted])

  return (
    <NavigationContainer linking={LinkingConfiguration}>
      <ModalPrivacy
        visible={modalPrivacyVisible}
        onSuccess={() => setModalPrivacyVisible(false)}
        onAbort={() => setModalPrivacyVisible(false)}
      />

      <ModalPatientGroup visible={patientGroupModalVisible} />

      <Stack.Navigator
        initialRouteName={loggedIn ? 'SignedIn' : 'SignedOut'}
        screenOptions={{
          headerShown: false,
          // ...commonScreenOptions,
        }}
      >
        {/* <Stack.Screen name="Init" component={InitScreen} /> */}

        {loggedIn ? (
          <Stack.Screen name="SignedIn" component={SignedInNavigator} />
        ) : (
          <Stack.Screen name="SignedOut" component={SignedOutNavigator} />
        )}

        <Stack.Screen
          name="NotFound"
          component={NotFoundScreen}
          options={{ title: 'Seite nicht gefunden' }}
        />

        <Stack.Screen
          name="ResetPassword"
          component={ResetPasswordScreen}
          options={{ title: 'Passwort zurücksetzen' }}
        />

        <Stack.Screen
          name="VerifyEmailAddress"
          component={VerifyEmailAddressScreen}
          options={{ title: 'E-Mail-Adresse verifizieren' }}
        />
      </Stack.Navigator>
    </NavigationContainer>
  )
}

export default AppNavigator
